import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { DsSwitchesIP, SaveEventType, SaveStatusObj, SOModule, UserType, ValidationItem, ValidationSummary } from '../../../../shared/misc-classes';
import { DataService } from '../../../../shared/dataservice.service';
import { ValidationDialog } from '../../../../dialogs/validation-dialog/validation-dialog';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Component({
  selector: 'ds-switches',
  templateUrl: './ds-switches.component.html',
  styleUrls: ['./ds-switches.component.css']
})
export class DsSwitchesComponent implements OnInit, OnChanges {

  @Input() dsSwitchesObj: DsSwitchesIP;
  @Input() soLockObtained: boolean;
  @Input() accessLevel: Array<UserType>;
  @Output() updateDatasheet: EventEmitter<SaveStatusObj> = new EventEmitter();

  disableForm: boolean = false;
  inputDisableMessage: string = 'This form is not yet enabled';
  readonlyAccess: boolean = false;
  Hvr: any = {};
  hasAccessEE: boolean = false;
  hasAccessME: boolean = false;
  hasAccessPM: boolean = false;
  lockFields: boolean = false; // After HOM lock

  constructor(public _dataService: DataService, public dialog: MatDialog) { }

  ngOnInit(): void {
  }
  ngOnChanges(): void {
    this.disableForm = true;
    if (this.soLockObtained == false) {
      this.inputDisableMessage = "You can't Edit";
    }
    else if (this.accessLevel.includes(this._dataService.userType) == false) {
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
    else {
      this.disableForm = false;
      // this.checkUserEnabled();
    }
    if (this._dataService.hasReadOnlyAccess) {
      this.readonlyAccess = true;
    }
    this.hasAccessEE = this._dataService.userType === (UserType.ELECTRICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
    this.hasAccessME = this._dataService.userType === (UserType.MECHANICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
    this.hasAccessPM = this._dataService.userType === (UserType.PROJECT_MANAGEMENT) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
    if (!this.dsSwitchesObj.parentSORef.isDatasheetSubOrderEnabled) {
      this.lockFields = false;
    }
    else {
      this.lockFields = true;
    }

  }

 sectionNoteChangePM(_event: any) {
    this.dsSwitchesObj.sectionNotePM = _event.target.value;
  }
  sectionNoteChangeEE(_event: any) {
    this.dsSwitchesObj.sectionNoteEE = _event.target.value;
  }
  sectionNoteChangeME(_event: any) {
    this.dsSwitchesObj.sectionNoteME = _event.target.value;
  }

  saveDS(_submitToNextSection: boolean) {
    if (this.updateDatasheet) {
      this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing,
        (_submitToNextSection == true ? SaveEventType.Submit_To_Next : SaveEventType.Save_Data)));
    }
  }
  reloadData() {
    if (this.updateDatasheet) {
      this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing, SaveEventType.Reload_Data));
    }
  }

  showSoValidation() {
    let _validList: Array<ValidationItem> = [];
    if (this.hasAccessEE) {
      _validList.push(new ValidationItem("EE Note", !!this.dsSwitchesObj.sectionNoteEE, " required to save Datasheet."));
    }
    if (this.hasAccessPM) {
      _validList.push(new ValidationItem("PM Note", !!this.dsSwitchesObj.sectionNotePM, " required to save Datasheet."));
    }
    if (this.hasAccessME) {
      _validList.push(new ValidationItem("ME Note", !!this.dsSwitchesObj.sectionNoteME, " required to save Datasheet."));
    }
    let vSummaryObj: ValidationSummary = new ValidationSummary("Validation Summary.", _validList);
    this.dialog.open(ValidationDialog, { width: '50%', data: vSummaryObj });
  }

  saveSOValidation(): boolean {
    if (this.hasAccessEE) {
      if (!this.dsSwitchesObj.sectionNoteEE) {
        return false;
      }
    }
    if (this.hasAccessPM) {
      if (!this.dsSwitchesObj.sectionNotePM) return false;
    }
    if (this.hasAccessME) {
      if (!this.dsSwitchesObj.sectionNoteME) return false;
    }
    return true;
  }
}

